export const QUERY_KEYS = {
  GET_ADDRESSES: "getAddresses",
  LIST_PAYMENT_METHODS: "listPaymentMethods",
  GET_PAYMENT_METHOD: "getPaymentMethod",
  GET_ORDER_BY_ID: "getOrderById",
  GET_ORDERS: "getOrders",
  GET_NOTIFICATIONS: "getNotifications",
  GET_HS_CODES_STATIC: "getHSCodesStatic",
  GET_HS_CODES_SEARCH: "getHSCodesSearch",
  GET_PASSWORD_RESET_TOKEN_VALIDATION: "getPasswordResetTokenValidation",
  GET_KEY_STATS: "getKeyStats",
  GET_COUNTRIES: "getCountries",
  GET_SUB: "getSub"
};
